export default "__VITE_PUBLIC_ASSET__bf7b6aa5__"